export const pages = {
  login: '/login',
  register: '/register',
  logout: '/logout',
  flatList: '/',
  flatCreate: '/flats/create',
  flatEdit: '/flats/edit/:flatId',
  bookingList: '/bookings',
  archiveList: '/archives',
  clientList: '/clients',
  hostList: '/hosts',
  blockedHostList: '/hosts/blocked',
  notifications: '/notifications',
  imports: '/imports',
  settings: '/settings',
}

export const getFlatEditPage = (id: number) => `/flats/edit/${id}`
